import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=b700dbba&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b700dbba')) {
      api.createRecord('b700dbba', component.options)
    } else {
      api.reload('b700dbba', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=b700dbba&", function () {
      api.rerender('b700dbba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29WYyS7k2OMKA/JS/comp/ImgFallback2.vue"
export default component.exports